module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n	<div style=\"padding: 3px;\">\n		")
    ; __append(escapeFn( item.name ))
    ; __append("\n	</div>\n	<div style=\"padding: 3px;\" data-id=\"")
    ; __append(escapeFn( item.id ))
    ; __append("\" on-click=\"onLocateClick\">\n		<div class=\"icon-12 icon-target\"></div>\n	</div>\n</div>")
  }
  return __output.join("");

}